<template>
	<div class="stats__filter">
		<main-filter>
			<div class="filters__item">
				<div class="stats__filters">
					<div class="stats-period">
						<div v-for="item in statsPeriod" :key="item" class="stats-period__item" :class="{'active': item === statsPeriodActive}" @click="getFormattedDate(item)">{{ item }}</div>
					</div>
					<div class="stats-input">
						<InputPeriod v-model="datePeriod"  :inputGray="true"></InputPeriod>
					</div>
				</div>
			</div>
			<div class="filters__item filters__item--3">
				<div class="filters__item--double ">
					<InputText label="Название компании" placeholder="Название" v-model="companyName" :inputGray="true" />
					<input-select label="Тип регистрации*" :inputGray="true">
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:placeholder="'Выберите тип'"
								ref="multiselectLegal"
								:options="legal"
								:label="'name'"
								:value-prop="'id'"
								:inputGray="true"
								v-model="legalSelected"
								/>
						</template>
					</input-select>	
				</div>
			</div>

			<div class="filters__item">
				<ProductCategories v-model="productGroups" ref="productGroups"/>
			</div>
			
			<div class="filters__item filters__item--2">
				<div class="filters__btns">
					<button type="submint" class="btn btn--color" @click="handleApplyFilters">Применить</button>
					<button class="btn btn--trans" @click="handleClearFilters">Сбросить фильтр</button>
				</div>
			</div>
		</main-filter>
	</div>
</template>



<script>
import {mapActions, mapGetters} from "vuex";
import { inject } from 'vue'
import moment from 'moment';
import InputPeriod from "@/components/base/utils/formElements/InputPeriod.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import MainFilter from "@/components/blocks/MainFilter.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import ProductCategories from "@/components/blocks/ProductCategories.vue";

export default {
	name: "StatsFilter",
	components: {InputPeriod, InputText, InputSelect, MainFilter, Multiselect, ProductCategories},
	data() {
		return {
			moment: moment,
			datePeriod: ['',''],
			statsPeriod: ['Сегодня', 'Вчера', 'Эта неделя', 'Этот месяц', 'Прошлый месяц'],
			statsPeriodActive: '',
			companyName: '',
			legalSelected: '',
			productGroups: ''
		}
	},
	computed: {
		...mapGetters({
			isLoading: 'isLoading',
		})
	},
	setup() {
		const legal = inject('legal')
		return {
			legal,
		}
	},
	methods: {
		handleApplyFilters() {
			const filter = {
				dateFrom: this.datePeriod[0] ? this.datePeriod[0].toLocaleDateString() : null,
				dateTo:  this.datePeriod[1] ? this.datePeriod[1].toLocaleDateString() : null,
				companyName: this.companyName,
				legalForm: this.legalSelected,
				productGroups: this.productGroups
			}
			this.updateFilter(filter)
		},

		handleClearFilters() {
			this.datePeriod = ['','']
			this.companyName = ''
			this.legalSelected = ''
			this.statsPeriodActive = ''
			this.$refs.productGroups.clearAll()
			this.updateFilter({
				dateFrom: null,
				dateTo: null,
				companyName: null,
				legalForm: null
			})
		},

		getFormattedDate(option) {
			const today = moment();
			this.statsPeriodActive = option

			switch(option) {
				case "Сегодня":
					this.datePeriod = [new Date(), new Date()] 
					break
				case "Вчера":
					this.datePeriod = [new Date(today.subtract(1, 'days').format('MM.DD.YYYY')), new Date(today.subtract(0, 'days').format('MM.DD.YYYY'))]
					break
				case "Эта неделя":
					this.datePeriod = [new Date(today.clone().startOf('isoWeek').format('MM.DD.YYYY')), new Date(today.clone().endOf('isoWeek').format('MM.DD.YYYY'))];
					break
				case "Этот месяц":
					this.datePeriod = [new Date(today.startOf('month').format('MM.DD.YYYY')), new Date(today.endOf('month').format('MM.DD.YYYY'))]
					break
				case "Прошлый месяц":
					this.datePeriod = [new Date(today.subtract(1, 'months').startOf('month').format('MM.DD.YYYY')), new Date(today.subtract(0, 'months').endOf('month').format('MM.DD.YYYY'))]
					break
				default:
					return "Invalid option";
			}
		},
		...mapActions({
			updateFilter: 'stats/updateFilter',
		})
	},
}
</script>